function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5001 5.41663C22.0459 5.41663 13.5417 13.9208 13.5417 24.375C13.5417 38.5937 32.5001 59.5833 32.5001 59.5833C32.5001 59.5833 51.4584 38.5937 51.4584 24.375C51.4584 13.9208 42.9543 5.41663 32.5001 5.41663ZM18.9584 24.375C18.9584 16.9 25.0251 10.8333 32.5001 10.8333C39.9751 10.8333 46.0417 16.9 46.0417 24.375C46.0417 32.175 38.2417 43.8479 32.5001 51.1333C26.8667 43.902 18.9584 32.0937 18.9584 24.375ZM29.7917 21.6666V16.25H35.2084V21.6666H40.6251V27.0833H35.2084V32.5H29.7917V27.0833H24.3751V21.6666H29.7917Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 32.5001,
  y1: 5.41663,
  x2: 32.5001,
  y2: 59.5833,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/GeoIcon.cb506321.svg";
export { SvgComponent as ReactComponent };